function generateDefaultUserAgentState() {
  return {};
}

function userAgentState(state = generateDefaultUserAgentState()) {
  return state;
}

export default userAgentState;
export {generateDefaultUserAgentState};
